export default {
  applicantName: null,
};
